import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { successToast, errorToast } from "../../Utils/toast";
import { closeModal } from "../../redux/features/modalSlice";

function EnquiryRemark({ data }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    remarks: "",
    followup_date: new Date().toISOString().split("T")[0],
    date: new Date().toISOString().split("T")[0],
    time: new Date().toTimeString().split(" ")[0],
    file: null,
  });

  const validateForm = () => {
    let newErrors = {};
    if (!formData.remarks.trim()) {
      newErrors.remarks = "Remark is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      if (!validateForm()) {
        setLoading(false);
        return;
      }

  const payload = {
  id: data.id,  
   type:data.type,                   
  status: data.newStatus,        
  admin_remark: formData.remarks,  
};

      const res = await data.onSubmit(payload);

      if (res?.success) {
        successToast(res.message || "Remark added successfully");
        if (data?.refreshRemarks) {
          await data.refreshRemarks();
        }
        dispatch(closeModal());
      } else {
        errorToast(res?.message || "Something went wrong");
      }
    } catch (err) {
      console.log(err);
      errorToast(err?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card p-3">
      <div className="alert alert-info py-2 mb-3">
        Status changing:{" "}
        <strong className="text-capitalize">
          {data?.currentStatus || "pending"}
        </strong>{" "}
        → <strong className="text-capitalize">{data?.newStatus}</strong>
      </div>

      <div className="mb-3">
        <label>
          Remark <span className="text-danger">*</span>
        </label>
        <textarea
          name="remarks"
          className={`form-control ${errors.remarks ? "is-invalid" : ""}`}
          rows="3"
          value={formData.remarks}
          onChange={(e) => {
            handleChange(e);
            if (errors.remarks) {
              setErrors((prev) => ({ ...prev, remarks: "" }));
            }
          }}
        />
        {errors.remarks && (
          <div className="invalid-feedback">{errors.remarks}</div>
        )}
      </div>

      <div className="d-flex gap-2">
        <button
          className="btn btn-danger"
          onClick={() => dispatch(closeModal())}
          disabled={loading}
        >
          Cancel
        </button>

        <button className="add-btn" onClick={handleSubmit} disabled={loading}>
          {loading ? "Saving..." : "Save Remark"}
        </button>
      </div>
    </div>
  );
}

export default EnquiryRemark;